// extracted by mini-css-extract-plugin
export default {"container":"HW14_container__Ga9vS","tech":"HW14_tech__pMarI","loading":"HW14_loading__wCJ1G"};